<template>
  <b-row>
    <b-col cols="6">
      <b-card title="Create Awesome 🙌">
        <b-card-text>This is your second page.</b-card-text>
        <b-card-text>Chocolate sesame snaps pie carrot cake pastry pie lollipop muffin. Carrot cake dragée chupa chups jujubes. Macaroon liquorice cookie wafer tart marzipan bonbon. Gingerbread jelly-o dragée chocolate.</b-card-text>
      </b-card>
    </b-col>
    <b-col cols="6">
      <b-card title="Create Awesome 🙌">
        <b-card-text>This is your second page.</b-card-text>
        <b-card-text>Chocolate sesame snaps pie carrot cake pastry pie lollipop muffin. Carrot cake dragée chupa chups jujubes. Macaroon liquorice cookie wafer tart marzipan bonbon. Gingerbread jelly-o dragée chocolate.</b-card-text>
      </b-card>
    </b-col>
    <b-col cols="12">
      <!-- <good-table-basic /> -->
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCardText, BCol, BRow,
} from 'bootstrap-vue'
// import GoodTableBasic from './trans/GoodTableBasic.vue'

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BCardText,

    // GoodTableBasic,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
